export const PlanningAndIssuesSummaryLinearStyle = {
  cardTypeRightPaddingStyle: {
    default: { padding: "0px 7.5px 0px 0px" },
    retro: { cursor: "pointer" },
    electric: { cursor: "pointer" },
  },
  cardTypeLeftPaddingStyle: {
    default: { padding: "0px 0px 0px 7.5px" },
    retro: { cursor: "pointer" },
    electric: { cursor: "pointer" },
  },
  cartTypeBothPaddingStyle: {
    default: { padding: "0px 7.5px 0px 7.5px" },
    retro: { cursor: "pointer" },
    electric: { cursor: "pointer" },
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/styles/PlanningAndIssueSummaryStyle.js